import { Injectable } from '@angular/core';
import {
  ExecuteActionQuotationInput,
  ExportVariables,
  GetQuotationAttachmentsQueryResponse,
  GetQuotationQueryResponse,
  ListQuotationsQueryResponse,
  ListQuotationsResult,
  Quotation,
  QuotationAttachmentsResponse,
  QuotationLabelInput,
} from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import { QuotationQueries } from './quotation.queries';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {
  constructor(
    private readonly apollo: Apollo,
    private readonly queries: QuotationQueries
  ) { }

  public async listQuotations({ where, options }): Promise<ListQuotationsResult> {
    const query = this.queries.listQuotations();
    const variables = {
      where,
      orderBy: options.orderBy,
      limit: options.limit,
      offset: options.offset,
    };
    return this.apollo.query<ListQuotationsQueryResponse>({ query, variables })
      .toPromise()
      .then((response) => {
        return {
          items: response.data.quotations.items,
          totalCount: response.data.quotations.totalCount,
          filtered: Boolean(
            where.createdAt_gte ||
            where.createdAt_lte ||
            where.agreementAt_gte ||
            where.agreementAt_lte ||
            where.total_gte ||
            where.total_lte ||
            where.identifier_contains ||
            where.locationId_in ||
            where.companyId_in ||
            where.maintenanceTypeId_in ||
            where.segmentId_in ||
            where.locationGroupId_in ||
            where.approvedByOrRefusedById_in ||
            where.status_in ||
            where.archived !== false ||
            where.maintenanceId_in ||
            where.labelId_in
          ),
        };
      });
  }

  public async getById(id: string): Promise<Quotation> {
    const query = this.queries.getQuotationById();
    const variables = { id };
    return this.apollo.query<GetQuotationQueryResponse>({
      query,
      variables
    }).toPromise()
      .then((response) => response.data.quotation);
  }

  public async getAttachments(id: string): Promise<QuotationAttachmentsResponse> {
    const query = this.queries.getQuotationAttachments();
    const variables = { id };
    return this.apollo.query<GetQuotationAttachmentsQueryResponse>({
      query,
      variables
    }).toPromise()
      .then((response) => response.data.quotation);

  }

  public async approveQuotation(input: ExecuteActionQuotationInput): Promise<void> {
    const mutation = this.queries.approveQuotation();
    const variables = { input };
    await this.apollo.mutate({ mutation, variables }).toPromise();
  }

  public async rejectQuotation(input: ExecuteActionQuotationInput): Promise<void> {
    const mutation = this.queries.rejectQuotation();
    const variables = { input };
    await this.apollo.mutate({ mutation, variables }).toPromise();
  }

  public async saveQuotationLabels(input: QuotationLabelInput, isRemove: boolean): Promise<void> {
    const mutation = isRemove ? this.queries.removeQuotationLabel() : this.queries.addQuotationLabel();
    const variables = { input };
    await this.apollo.mutate({ mutation, variables}).toPromise();
  }
}
